import React from 'react';
import { SettingsIcon, BatteryChargingIcon, WandSparklesIcon, CloudIcon, CameraIcon, ShieldCheckIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
import { CTAButton } from './CTAButton';
type Module = {
  title: string;
  icon: React.ElementType;
  items: string[];
};
const MODULES: Module[] = [{
  title: 'Configuraciones esenciales',
  icon: SettingsIcon,
  items: ['Qué ajustes activar desde el primer día y cuáles desactivar para mejorar el rendimiento.', 'Cómo personalizar la pantalla de inicio para tener todo más organizado y accesible.', 'Cómo configurar Face ID, código de seguridad y pantalla de bloqueo correctamente.']
}, {
  title: 'Batería y rendimiento',
  icon: BatteryChargingIcon,
  items: ['Las razones reales por las que tu batería se drena rápido.', 'Qué apps y ajustes consumen más energía sin que lo notes.', 'Pasos simples para que tu iPhone dure más horas sin cargarlo.']
}, {
  title: 'Funciones ocultas y trucos',
  icon: WandSparklesIcon,
  items: ['Gestos rápidos que te ahorran tiempo todos los días.', 'Atajos del teclado para escribir más rápido.', 'Funciones que ya tienes pero nunca usaste.', 'Trucos para buscar cualquier cosa en segundos.', 'Cómo copiar texto desde imágenes y fotos.', 'Cómo escanear documentos sin aplicaciones externas.']
}, {
  title: 'Herramientas Apple que debes conocer',
  icon: CloudIcon,
  items: ['iCloud: cómo funciona y cómo usarlo para proteger tus archivos y fotos.', 'AirDrop: cómo compartir fotos, archivos y contactos en segundos.', 'Face ID: cómo configurarlo para que funcione siempre bien.', 'Siri: trucos y comandos útiles para el día a día.', 'Atajos: cómo automatizar tareas simples y ahorrar tiempo.', 'Notas, Recordatorios, Calendario y Fotos: cómo organizarlas mejor.']
}, {
  title: 'Cámara',
  icon: CameraIcon,
  items: ['Cómo usar el modo retrato, el modo noche y los ajustes de la cámara.', 'Trucos para tomar mejores fotos con buena luz y composición.', 'Cómo grabar mejores videos.', 'Cómo editar fotos directamente desde el iPhone.']
}, {
  title: 'Privacidad y seguridad',
  icon: ShieldCheckIcon,
  items: ['Cómo revisar los permisos de tus apps.', 'Cómo proteger tus contraseñas.', 'Cómo cuidar tu ubicación, tu información personal y tus datos.']
}];
export function Curriculum() {
  return <Section className="bg-ink-950" data-id="element-83" data-mp="2uw59fdnmh6h1">
      <SectionTitle eyebrow="Contenido" data-id="element-84" data-mp="2uwey8xwxl7l5">
        Esto es lo que encontrarás dentro de iPhone Experto
      </SectionTitle>

      <div className="grid gap-4 md:grid-cols-2" data-id="element-85" data-mp="34t9ypmcrli22">
        {MODULES.map(({
        title,
        icon: Icon,
        items
      }) => <article key={title} className="rounded-3xl border border-white/8 bg-ink-900 p-6 sm:p-7" data-id="element-86" data-mp="39jqal20xsvmb">
            <div className="mb-5 flex items-center gap-3" data-id="element-87" data-mp="3ejcq5i48mnya">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent/15" data-id="element-88" data-mp="3ekw4h36c2oxf">
                <Icon className="h-5 w-5 text-accent-soft" aria-hidden="true" data-id="element-89" data-mp="3iitvmbjnzl3g" />
              </span>
              <h3 className="text-lg font-bold text-white" data-id="element-90" data-mp="3nhezqm21eox6">{title}</h3>
            </div>
            <ul className="space-y-3" data-id="element-91" data-mp="1bubed2i6xg1o">
              {items.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-white/60" data-id="element-92" data-mp="16w9tqd5498o3">
                  <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-accent" aria-hidden="true" data-id="element-93" data-mp="12wrbxq8lddph" />
                  <span data-id="element-94" data-mp="xxoeaquxy9rj">{item}</span>
                </li>)}
            </ul>
          </article>)}
      </div>

      <p className="mt-8 text-center text-base text-white/70 sm:text-lg" data-id="element-95" data-mp="1ulm3pf89pkrg">
        Y mucho más, todo explicado en pasos simples, con lenguaje claro y sin
        tecnicismos.
      </p>

      <div className="mt-10" data-id="element-96" data-mp="1ltk4fk9xqair">
        <CTAButton className="items-center" data-id="element-97" data-mp="1lsr719wv8xda" />
      </div>
    </Section>;
}